import { ButtonProps } from "@tecma/ds/lib/components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { modalActions } from "store/sagas/modal/modal.actions";
import {
  getModalPropsSelector,
  isOpenModalSelector,
} from "store/slices/modal/selector";

const useModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isOpenModalSelector);
  const alertProps = useSelector(getModalPropsSelector);

  const onClose = () => {
    dispatch(modalActions.CLOSE_MODAL());
  };

  const getTitle = () => {
    return alertProps?.title;
  };

  const getContent = () => {
    return alertProps?.content;
  };

  const getLeftActionProps = (): ButtonProps | null => {
    if (alertProps?.actions?.leftAction) {
      return {
        ...alertProps.actions.leftAction,
        children: alertProps.actions.leftAction.text,
      };
    }
    return null;
  };

  const getRightActionProps = (): ButtonProps | null => {
    if (alertProps?.actions?.rightAction) {
      return {
        ...alertProps?.actions?.rightAction,
        children: alertProps?.actions?.rightAction?.text,
      };
    }
    return null;
  };

  return {
    isOpen,
    title: getTitle(),
    content: getContent(),
    onClose,
    leftActionProps: getLeftActionProps(),
    rightActionProps: getRightActionProps(),
  };
};

export default useModal;
